import type { ArquivosAplicativo } from "../../../services/arquivosAplicativo"

export type ArquivosAplicativoModel = ArquivosAplicativo

export const ArquivosAplicativoInicial: ArquivosAplicativoModel = {
    urlLogo: null,
    urlImgAindaNaoTemSelo: null,
    urlImagemCabecalho: null,
    urlArquivoFireBase: null,
    urlSelo: null,
    urlBotaoCarimbar: null,
    urlRodape: null,
    urlFundoGenerico: null,
    urlSplash: null,
    urlImagemDelivery: null,
    urlImagemLojas: null,
    urlImagemComSelo: null,
    urlImgTelaSelos: null,
    urlImgTelaPromocao: null,
    urlFundoSite: null,
    urlImgBaner: null,
    podeEditar: true,
    ehClienteFiel: false,
}

export type CampoArquivo = {
    campo: keyof Omit<ArquivosAplicativoModel, "podeEditar" | "ehClienteFiel">
    label: string
    tamanho?: string
    somenteClienteFiel?: boolean
    aceitarTipos?: string
}

export type SecaoArquivos = {
    titulo: string
    campos: CampoArquivo[]
}

export const SECOES_ARQUIVOS: SecaoArquivos[] = [
    {
        titulo: "Necessários",
        campos: [
            { campo: "urlLogo", label: "Logo", tamanho: "192x192 (não pode ser redonda)" },
            { campo: "urlImgAindaNaoTemSelo", label: "Logo", tamanho: "256x256" },
            { campo: "urlImagemCabecalho", label: "Imagem Cabeçalho", tamanho: "480x82" },
            {
                campo: "urlArquivoFireBase",
                label: "Arquivo FireBase",
                tamanho: "google-services.json",
                somenteClienteFiel: true,
                aceitarTipos: ".json,application/json",
            },
        ],
    },
    {
        titulo: "Adicionais",
        campos: [
            { campo: "urlSelo", label: "Ícone Selo", tamanho: "150x150 recomendado" },
            {
                campo: "urlBotaoCarimbar",
                label: "Ícone Botão Carimbar",
                tamanho: "250x250 recomendado",
                somenteClienteFiel: true,
            },
            { campo: "urlRodape", label: "Opções Rodapé", somenteClienteFiel: true },
            { campo: "urlFundoGenerico", label: "Fundo Genérico Interno", tamanho: "727x1000 recomendado" },
            { campo: "urlSplash", label: "Fundo Splash", tamanho: "727x1000 recomendado" },
            { campo: "urlImagemDelivery", label: "Fundo Delivery", tamanho: "727x1000 recomendado" },
            { campo: "urlImagemLojas", label: "Fundo Lojas", tamanho: "727x1000 recomendado" },
            { campo: "urlImagemComSelo", label: "Fundo c/ Selo", tamanho: "727x1000 recomendado" },
            { campo: "urlImgTelaSelos", label: "Fundo s/ Selo", tamanho: "727x1000 recomendado" },
            { campo: "urlImgTelaPromocao", label: "Fundo Promoção", tamanho: "727x1000 recomendado" },
            { campo: "urlFundoSite", label: "Banner Site", tamanho: "1024x768 ou superior" },
            { campo: "urlImgBaner", label: "Fundo Pattern Site", somenteClienteFiel: true },
        ],
    },
]
